/**
 * Scrolls to #ways-to-earn on a cold page load (e.g. a menu link opened
 * in a new tab). Same approach as the #refer-a-friend handler in
 * rewards-refer-faq.js — see the comment there for the full reasoning.
 * In short: the browser's native jump-to-fragment fires before the Yotpo
 * widgets above this section have mounted and pushed it down the page,
 * so this strips the hash up front (killing the native jump) and does
 * exactly one smooth scroll once the page goes quiet, or after a short
 * fallback timeout.
 */
(function () {
  if (window.location.hash !== "#ways-to-earn") return;

  var path = location.pathname + location.search;
  history.replaceState(null, "", path);

  var done = false;
  var debounceTimer, hardStop, observer;

  function scrollToSection() {
    if (done) return;
    done = true;
    clearTimeout(debounceTimer);
    clearTimeout(hardStop);
    observer.disconnect();

    var target = document.getElementById("ways-to-earn");
    if (!target) return;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY, behavior: "smooth" });
    // Restore the hash (without re-triggering a native scroll) so the URL
    // still reflects the anchor for sharing/bookmarking.
    history.replaceState(null, "", path + "#ways-to-earn");
  }

  window.addEventListener("load", function () {
    observer = new ResizeObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(scrollToSection, 400);
    });
    observer.observe(document.body);

    // Fallback if the page never actually goes quiet within this
    // window — still scroll once rather than wait indefinitely.
    hardStop = setTimeout(scrollToSection, 1800);
  });
})();
